import React from "react";
import data from "../../data/blog/forthwroth.json";

function ForthSection() {
  const Data = data[3]; // Access ParkingOptions directly

  return (
    <div className="mx-auto max-w-5xl px-4 text-lg text-[#2b3252]">
      {Data.parkingOptions.map((item, index) => {
        return (
          <div key={index} className="mb-8">
            {item.title && <h2 id={item.id} className="blogtitle">{item.title}</h2>}
            {item.description && (
              <p className="blogcontent">{item.description}</p>
            )}

            {item.sections.map((section, sectionIndex) => {
              return (
                <div key={sectionIndex} className="mb-6">
                  <h3 className="blogSubtitle">{section.heading}</h3>
                  {section.image && (
                <img
                  src={section.image}
                  alt={section.heading}
                  className="mb-4 rounded-[20px]"
                />
              )}
                  <div
                    className="blogcontent"
                    dangerouslySetInnerHTML={{ __html: section.content }}
                  />

                  {section.subsections.map((subsection, subIndex) => {
                    return (
                      <div key={subIndex} className="mb-1">
                        <ul className="pl-4">
                          <li
                            className="list-disc blogcontent"
                            dangerouslySetInnerHTML={{
                              __html: subsection.duration,
                            }}
                          ></li>
                   </ul>
                        {subsection.details && (
                          <ul className="pl-6">
                            {subsection.details.map((detail, detailIndex) => (
                              <li key={detailIndex} style={{listStyle:"circle"}} className="text-lg  ">
                                {detail}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}

export default ForthSection;
